import * as React from 'react';
import { Component } from 'react';
// import { NavMenu } from '../NavMenu/NavMenu';
import GlobalStatusBarComponent from './GlobalStatusBar';

export class Layout extends Component {

    public render() {

        return (
            <div className={'application'}>
                <GlobalStatusBarComponent />
                {/* <div className={'menu'}>
                    <NavMenu />
                </div> */}
                <div className={'page-content'}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.tsx